


import React from 'react';
import { FaEnvelope, FaMapMarkerAlt,FaPhoneAlt  } from 'react-icons/fa';
import LabLogo from '../assets/logo1.png'; // <-- import your logo

export default function ContactInfo() {
  return (
    <section id="contact" className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl font-bold mb-10 text-center text-red-600">Contact Us</h2>

        <div className="grid md:grid-cols-2 gap-10 items-start">

          {/* Contact Info Card */}
          <div className="bg-gradient-to-br from-red-50 to-white p-10 rounded-2xl shadow-xl flex flex-col justify-center space-y-4 h-70">

            {/* Phone with Lab Logo and Name */}
            <div className="flex items-center space-x-3">
              <img 
                src={LabLogo} 
                alt="Lab Logo" 
                className="w-10 h-10 rounded-full"
              />
              <div>
                <p className="text-lg font-medium">LABTOUCH PATHOLOGY LAB</p>
                
              </div>
            </div>

 {/* Contact */}
            <p className="text-lg flex items-center space-x-3">
              <FaPhoneAlt  className="text-red-600" />
              <span>+91-7507630030</span>
            </p>

            {/* Email */}
            <p className="text-lg flex items-center space-x-3">
              <FaEnvelope className="text-red-600" />
              <span>labtouch2020@gmail.com</span>
            </p>

            {/* Address */}
<p className="text-lg flex items-start space-x-3">
  <FaMapMarkerAlt className="text-red-600 mt-1 w-6 h-6 flex-shrink-0" />
  <span className="break-words">
    Near Mamta sweet corner Dhamaveer Sambhaji Raje chowk, Adarsh Nagar, Dighi, Pune, Maharashtra 411015
  </span>
</p>

          </div>

          

{/* <div className="w-full h-64 md:h-84 rounded-2xl overflow-hidden shadow-xl relative"> */}
 <div className="w-full h-80 md:h-95 rounded-2xl overflow-hidden shadow-xl relative">

  {/* Actual Map */}
  <iframe
    title="Labtouch Pathology Lab Map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2988.311783030797!2d73.8660317751941!3d18.6222965824911!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c7808f1a7c55%3A0x9f9c2c3db5500dc7!2sLabtouch%20Pathology%20lab!5e1!3m2!1sen!2sin!4v1765647658710!5m2!1sen!2sin"
    className="w-full h-full border-0"
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>

  {/* Overlay Link */}
  <a
    href="https://maps.app.goo.gl/B1zbjE7Dbg9sV5g77"
    target="_blank"
    rel="noopener noreferrer"
    className="absolute inset-0 z-10"
  ></a>
</div>

        </div>
      </div>
    </section>
  );
}
